import React from 'react'
import { Formik, Form } from 'formik'
import { confirmable, createConfirmation } from 'react-confirm'

import Popper from '@material-ui/core/Popper'
import Grid from '@material-ui/core/Grid'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Button from '@material-ui/core/Button'

import { TextField, PhoneField } from '../../form'

const CustomerForm = ({
  show,
  proceed,
  dismiss,
  cancel,
  cod,
  name,
  anchorEl
}) => {
  console.log(cod, name, anchorEl)
  const id = show ? 'faked-reference-popper' : null
  return (
    <Popper id={id} open={show} anchorEl={anchorEl}>
      <Formik initialValues={{ cod, name }} onSubmit={proceed}>
        {({
          handleSubmit
          /* and other goodies */
        }) => (
          <Form>
            <Card>
              <CardContent>
                <Grid container spacing={16}>
                  <Grid item sm={12}>
                    <TextField required fullWidth name="name" label="Nome" />
                  </Grid>
                  <Grid item sm={6}>
                    <TextField required fullWidth name="cod" label="CPF/CNPJ" />
                  </Grid>
                  <Grid item sm={6}>
                    <PhoneField fullWidth name="phone" label="Telefone" />
                  </Grid>
                </Grid>
              </CardContent>
              <CardActions>
                <Button size="small" onClick={cancel}>
                  Cancelar
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  color="secondary"
                  onClick={handleSubmit}>
                  Salvar
                </Button>
              </CardActions>
            </Card>
          </Form>
        )}
      </Formik>
    </Popper>
  )
}

const CustomerFormPopper = confirmable(CustomerForm)
export default createConfirmation(CustomerFormPopper)
